"use strict";
exports.__esModule = true;
exports.MayBpSoftCreditCheckExperiment = exports.MayBpSoftCreditCheckVariantValues = void 0;
var types_1 = require("../types");
var MayBpSoftCreditCheckVariantValues;
(function (MayBpSoftCreditCheckVariantValues) {
    MayBpSoftCreditCheckVariantValues[MayBpSoftCreditCheckVariantValues["v1"] = 0] = "v1";
    MayBpSoftCreditCheckVariantValues[MayBpSoftCreditCheckVariantValues["v2"] = 1] = "v2";
})(MayBpSoftCreditCheckVariantValues = exports.MayBpSoftCreditCheckVariantValues || (exports.MayBpSoftCreditCheckVariantValues = {}));
exports.MayBpSoftCreditCheckExperiment = {
    variantID: 'may_bp_soft_credit_check',
    controlValue: types_1.CONTROL,
    variantValues: MayBpSoftCreditCheckVariantValues
};
